import { Button } from "src/components/ui-components/Button/Button";
import modal from "src/components/ui-components/Modal/ModalContent.module.css";
import { useChangeDatasetVisibility } from "../hooks/useChangeDatasetVisibility";

export const ChangeVisibilityModalContent = ({
  onDismiss,
  isPrivate,
  tableName,
}: {
  onDismiss: () => void;
  isPrivate: boolean;
  tableName: string;
}) => {
  const { onChangeDatasetVisibility, isLoading } = useChangeDatasetVisibility({
    tableName,
    onComplete: onDismiss,
  });

  return (
    <div className={modal.body}>
      <div className={modal.header}>
        <div className={modal.titleRow}>
          <h2>
            {isPrivate
              ? "Turning a dataset public makes it usable for the entire Dune community."
              : "Making a dataset private will break queries outside this workspace."}
          </h2>
        </div>
      </div>

      <div className={modal.buttons}>
        <Button size="M" theme="tertiary" onClick={onDismiss}>
          Cancel
        </Button>

        <Button
          size="M"
          theme="primary"
          onClick={() => onChangeDatasetVisibility(!isPrivate)}
          disabled={isLoading}
        >
          Make dataset {isPrivate ? "public" : "private"}
        </Button>
      </div>
    </div>
  );
};
